import dayjs from 'dayjs';
import translate from '@/utils/translate';
import {DefinedPreset} from '@/components/date-range-picker/types';

const getCampaignStatsPresets = (): DefinedPreset[] => [
  {
    id: 'last-7-days',
    label: translate('Last 7 Days'),
    startDate: dayjs().subtract(7, 'day').toDate(),
    endDate: dayjs().toDate(),
  },
  {
    id: 'last-30-days',
    label: translate('Last 30 Days'),
    startDate: dayjs().subtract(30, 'day').toDate(),
    endDate: dayjs().toDate(),
  },
  {
    id: 'this-month',
    label: translate('This Month'),
    startDate: dayjs().startOf('month').toDate(),
    endDate: dayjs().toDate(),
  },
  {
    id: 'last-month',
    label: translate('Last Month'),
    startDate: dayjs().subtract(1, 'month').startOf('month').toDate(),
    endDate: dayjs().subtract(1, 'month').endOf('month').toDate(),
  },
  {
    id: 'last-3-months',
    label: translate('Last 3 Months'),
    startDate: dayjs().subtract(3, 'month').startOf('month').toDate(),
    endDate: dayjs().toDate(),
  },
];

export default getCampaignStatsPresets;
